import React, { useState } from 'react';
import { AIAssistantDrawer, FloatingButton } from 'features/ai-assistant/components';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { useUserContext } from 'providers/UserProvider';
import { Permissions } from 'services/Authorization';
import { When } from 'UI/components/atoms';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';
import { isFeatureAccessible } from 'utils/featureAccesible';

export const AIAssistantManager = () => {
  const [user] = useUserContext();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const enableAIAssistant = isFeatureAccessible({
    checkIfFeatureFlagEnabled,
    featureFlag: FeatureFlags.AIAssistant,
    permission: Permissions.AIIntegrations.Assistant,
    user
  });
  const [openAIAssistant, setOpenAIAssistant] = useState(false);

  const handleOpenAIAssistant = () => {
    setOpenAIAssistant(true);
  };

  const handleCloseAIAssistant = () => {
    setOpenAIAssistant(false);
  };

  return user && enableAIAssistant ? (
    <>
      <When condition={!openAIAssistant}>
        <FloatingButton
          onClick={handleOpenAIAssistant}
          storageKey={PERSISTENCE_KEYS.AI.ASSISTANT_POSITION}
        />
      </When>
      <When condition={openAIAssistant}>
        <AIAssistantDrawer open={openAIAssistant} onClose={handleCloseAIAssistant} />
      </When>
    </>
  ) : null;
};
